import { Injectable } from '@angular/core';
import { NEVER } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SharePointService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';
import { ElementHistoryDocument } from 'src/app/models/domain';

@Injectable({
  providedIn: 'root',
})
export class SiriusElementHistoryDocumentService {
  private readonly state = new CollectionState<ElementHistoryDocument>();

  public readonly siriusElementHistoryDocuments$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly sharePointService: SharePointService) {}

  public loadSiriusElementHistoryDocumentsByDesignId(designId: string) {
    this.state.setLoading(true);

    return this.sharePointService.getSiriusElementHistoryDocumentsForDesignId(designId).pipe(
      tap((siriusEhds) => {
        this.state.set(siriusEhds);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }
}
